const state: PaymentStateObj = {};

export default { ...state };
